<template>
  <GlobusHeader
    v-if="showGlobusHeader"
  />
  <VisualizerHeader
    v-show="showVisualizerHeader"
  />
  <RouterView />
  <NotificationBlock />
  <GlobalLoader v-if="showGlobalLoader" />
  <ProjectHasntModuleDialog v-if="store.isShowProjectNoModuleDialog" />
</template>

<script setup>
import GlobalLoader from "@/components/common/Preloader/GlobalLoader.vue";
import GlobusHeader from "@/components/GlobusHeader.vue";
import NotificationBlock from "@/components/Notification/NotificationBlock.vue";
import {useStore} from "@/store";
import {changeShow} from "@/composables/ModuleCommunication";
import {modules} from "@/composables/constans/modules";
import {exit} from "@/composables/functionExit";
import {computed, onBeforeUnmount, onMounted} from "vue";
import {useRouter} from "vue-router";
import {personalAreaInitialize} from "@/composables/PersonalAreaInitialize";
import ProjectHasntModuleDialog from "@/components/ProjectHasntModuleDialog.vue";
import VisualizerHeader from "@/components/VisualizerHeader.vue";

const store = useStore();
const router = useRouter();

onMounted(() => {
  const globusLanguage = localStorage.getItem("globusLanguage");

  if (globusLanguage) {
    store.language.code = globusLanguage;
  } else {
    localStorage.setItem("globusLanguage", "ru");
    store.language.code = "ru";
  }

  store.loader = true;
  setListener();
  window.storeLK.language.code = store.language.code;
});

const onSetModule = async (event) => {
  const module = modules.find(item => item.dataName === event.detail.module);

  module ? store.activeModule = module : store.activeModule = {name: "Личный кабинет", dataName: "module_lk"};

  store.routing = event.detail.routing;
  store.mainHrefApp = event.detail.path;
  await personalAreaInitialize();
  store.isInitialized = true;
};

const onGoToProjectEdit = (event) => {
  const projectId = event.detail.projectId;
  const tab = event.detail.tab;
  router.push(`/lk/projects/edit/${projectId}?tab=${tab}`);
  changeShow(false);
};

const onGoToLogin = () => {
  exit();
  changeShow(false);
};

const setListener = () => {
  window.addEventListener("SetModule", onSetModule);
  window.addEventListener("GoToProjectEdit", onGoToProjectEdit);
  window.addEventListener("GoToLogin", onGoToLogin);
};

const removeListeners = () => {
  window.removeEventListener("SetModule", onSetModule);
  window.removeEventListener("GoToProjectEdit", onGoToProjectEdit);
  window.removeEventListener("GoToLogin", onGoToLogin);
};

onBeforeUnmount(() => {
  removeListeners();
});

const showGlobusHeader = computed(() => {
  return !["/login", "/under-construction"].includes(router.currentRoute.value.path)
      && store.activeModule.dataName !== "module_visualizer";
});

const showVisualizerHeader = computed(() => {
  return router.currentRoute.value.fullPath !== "/login"
      && store.activeModule.dataName === "module_visualizer";
});

const showGlobalLoader = computed(() => {
  return store.loader && router.currentRoute.value.path !== "/under-construction";
});
</script>

<style lang="scss" scoped></style>
